const isClassNamesObjectArg = (arg) => typeof arg === 'object';

export { isClassNamesObjectArg };
